// extracted by mini-css-extract-plugin
export default {"fullWidth":"An-z","image":"Bn-z","lazyLoadPicture":"Cn-z","lazyLoadSpinner":"Dn-z","lazyLoadSpin":"En-z","lazyLoadImage":"Fn-z","hasStyledAspectRatio":"Gn-z"};